import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Define TypeScript interfaces for our data structures
interface Course {
  id: number,
  title: string;
  subject: string;
  instructor: string;
  rating: number;
  reviewCount: number;
  price: number;
  discountPrice: number;
  imageUrl: string;
  examFocus: string;
  badges: string[];
  problems: number;
  difficulty: string;
}

interface CourseCategory {
  id: string;
  name: string;
}

interface CoursesByCategory {
  [key: string]: Course[];
}

const ProblemBasedCoursesApp: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>('jee12');
  
  // All available course categories
  const courseCategories: CourseCategory[] = [
    { id: 'jee12', name: 'JEE Main Class 12' },
    { id: 'jee11', name: 'JEE Main Class 11' },
    { id: 'neet12', name: 'NEET Class 12' },
    { id: 'neet11', name: 'NEET Class 11' }
  ];
  
  // Sample course data for each category
  const coursesByCategory: CoursesByCategory = {
    jee12: [
      {
        id: 40,
        title: "JEE Physics Problem Solving - Class 12",
        subject: "Physics",
        instructor: "MG Hussain",
        rating: 4.9,
        reviewCount: 1456,
        price: 4999,
        discountPrice: 999,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/21.png",
        examFocus: "JEE Main & Advanced",
        badges: ["Bestseller", "High Success Rate"],
        problems: 2500,
        difficulty: "Advanced"
      },
      {
        id: 41,
        title: "JEE Chemistry Problem Solving - Class 12",
        subject: "Chemistry",
        instructor: "MG Hussain",
        rating: 4.8,
        reviewCount: 1278,
        price: 4999,
        discountPrice: 999,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/23.png",
        examFocus: "JEE Main & Advanced",
        badges: ["Top Rated"],
        problems: 2200,
        difficulty: "Advanced"
      },
      {
        id: 42,
        title: "JEE Mathematics Problem Solving - Class 12",
        subject: "Mathematics",
        instructor: "MG Hussain",
        rating: 4.9,
        reviewCount: 1532,
        price: 4999,
        discountPrice: 999,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/25.png",
        examFocus: "JEE Main & Advanced",
        badges: ["Most Popular", "Top Scorer"],
        problems: 3000,
        difficulty: "Advanced"
      }
    ],
    jee11: [
      {
        id: 37,
        title: "JEE Physics Problem Solving - Class 11",
        subject: "Physics",
        instructor: "MG Hussain",
        rating: 4.8,
        reviewCount: 1245,
        price: 4999,
        discountPrice: 999,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/20.png",
        examFocus: "JEE Main & Advanced",
        badges: ["Foundation Course"],
        problems: 2000,
        difficulty: "Intermediate"
      },
      {
        id: 38,
        title: "JEE Chemistry Problem Solving - Class 11",
        subject: "Chemistry",
        instructor: "MG Hussain",
        rating: 4.7,
        reviewCount: 1167,
        price: 4999,
        discountPrice: 999,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/22.png",
        examFocus: "JEE Main & Advanced",
        badges: ["Concept Builder"],
        problems: 1800,
        difficulty: "Intermediate"
      },
      {
        id: 39,
        title: "JEE Mathematics Problem Solving - Class 11",
        subject: "Mathematics",
        instructor: "MG Hussain",
        rating: 4.8,
        reviewCount: 1322,
        price: 4999,
        discountPrice: 999,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/24.png",
        examFocus: "JEE Main & Advanced",
        badges: ["Comprehensive"],
        problems: 2200,
        difficulty: "Intermediate"
      }
    ],
    neet12: [
      {
        id: 19,
        title: "NEET Physics Problem Solving - Class 12",
        subject: "Physics",
        instructor: "MG Hussain",
        rating: 4.9,
        reviewCount: 1356,
        price: 7499,
        discountPrice: 3749,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/3_20241024_233833_0001_39uLfEH.png",
        examFocus: "NEET",
        badges: ["Bestseller", "Exam Focused"],
        problems: 2000,
        difficulty: "Advanced"
      },
      {
        id: 23,
        title: "NEET Chemistry Problem Solving - Class 12",
        subject: "Chemistry",
        instructor: "MG Hussain",
        rating: 4.8,
        reviewCount: 1178,
        price: 7499,
        discountPrice: 3749,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/6_20241024_233834_0004.png",
        examFocus: "NEET",
        badges: ["High Success"],
        problems: 1800,
        difficulty: "Advanced"
      },
      {
        id: 21,
        title: "NEET Biology Problem Solving - Class 12",
        subject: "Biology",
        instructor: "Danish Sir",
        rating: 4.9,
        reviewCount: 1582,
        price: 7499,
        discountPrice: 3749,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/4_20241024_233834_0002.png",
        examFocus: "NEET",
        badges: ["Most Popular", "Top Rated"],
        problems: 2500,
        difficulty: "Advanced"
      }
    ],
    neet11: [
      {
        id: 18,
        title: "NEET Physics Problem Solving - Class 11",
        subject: "Physics",
        instructor: "MG Hussain",
        rating: 4.7,
        reviewCount: 1145,
        price: 6499,
        discountPrice: 3249,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/2_20241024_233833_0000.png",
        examFocus: "NEET",
        badges: ["Foundation Course"],
        problems: 1500,
        difficulty: "Intermediate"
      },
      {
        id: 22,
        title: "NEET Chemistry Problem Solving - Class 11",
        subject: "Chemistry",
        instructor: "MG Hussain",
        rating: 4.7,
        reviewCount: 1067,
        price: 6499,
        discountPrice: 3249,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/7_20241024_233834_0005.png",
        examFocus: "NEET",
        badges: ["Comprehensive"],
        problems: 1600,
        difficulty: "Intermediate"
      },
      {
        id: 20,
        title: "NEET Biology Problem Solving - Class 11",
        subject: "Biology",
        instructor: "Danish Sir",
        rating: 4.8,
        reviewCount: 1382,
        price: 6499,
        discountPrice: 3249,
        imageUrl: "https://naendapi.naecoaching.com/media/courses/5_20241024_233834_0003.png",
        examFocus: "NEET",
        badges: ["Most Popular"],
        problems: 2000,
        difficulty: "Intermediate"
      }
    ]
  };

  // Get subject-specific gradients
  const getSubjectGradient = (subject: string): string => {
    const subjectGradients: {[key: string]: string} = {
      "Physics": "from-blue-600 to-indigo-700",
      "Chemistry": "from-green-600 to-emerald-700",
      "Biology": "from-teal-600 to-green-700",
      "Mathematics": "from-purple-600 to-indigo-700"
    };
    
    return subjectGradients[subject] || "from-gray-600 to-gray-700";
  };

  // Render star rating
  const renderStars = (rating: number): JSX.Element => {
    return (
      <div className="flex">
        {[1, 2, 3, 4, 5].map((star) => (
          <span key={star} className={star <= Math.round(rating) ? "text-yellow-400" : "text-gray-300"}>
            ★
          </span>
        ))}
      </div>
    );
  };

  // Calculate discount percentage
  const getDiscountPercentage = (price: number, discountPrice: number): number => {
    return Math.round(((price - discountPrice) / price) * 100);
  };

  // Problem Course Card Component
  const ProblemCourseCard: React.FC<{ course: Course }> = ({ course }) => {
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const gradient = getSubjectGradient(course.subject);
    const discountPercentage = getDiscountPercentage(course.price, course.discountPrice);
    
    return (
      <div 
        className="w-72 bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl relative"
        style={{ transform: isHovered ? 'translateY(-8px)' : 'none' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Card Header with Image */}
        <div className={`relative h-40 bg-gradient-to-r ${gradient}`}>
          <img 
            src={course.imageUrl} 
            alt={course.title}
            className="w-full h-full object-cover "
          />
          
          {/* Badges */}
          <div className="absolute top-3 left-3 flex gap-2">
            {course.badges && course.badges.map((badge, index) => (
              <span 
                key={index} 
                className="px-2 py-1 bg-white/90 text-xs font-bold rounded-full shadow-sm text-purple-800"
              >
                {badge}
              </span>
            ))}
          </div>
          
          {/* Problem Count Badge */}
          <div className="absolute bottom-3 right-3">
            <span className="px-3 py-1 bg-black/70 text-white text-sm font-bold rounded-lg">
              {course.problems}+ Problems
            </span>
          </div>
        </div>
        
        {/* Card Content */}
        <div className="p-5">
          <h3 className="text-lg font-bold text-gray-800 line-clamp-2 h-14">{course.title}</h3>
          
          <p className="text-sm text-gray-600 mt-2">by {course.instructor}</p>
          
          <div className="flex items-center mt-2">
            <span className="text-amber-500 font-bold mr-1">{course.rating}</span>
            {renderStars(course.rating)}
            <span className="text-xs text-gray-500 ml-1">({course.reviewCount})</span>
          </div>
          
          <div className="flex items-center justify-between mt-3 text-sm text-gray-600">
            <span className="flex items-center">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {course.examFocus}
            </span>
            
            <span className="flex items-center text-xs font-medium px-2 py-1 bg-gray-100 rounded-full">
              {course.difficulty}
            </span>
          </div>
          
          {/* Price and CTA */}
          <div className="mt-5 pt-4 border-t border-gray-100 flex justify-between items-center">
            <div>
              <span className="text-lg font-bold text-gray-800">₹{course.discountPrice}</span>
              <span className="text-sm text-gray-500 line-through ml-2">₹{course.price}</span>
              <span className="ml-2 text-green-600 text-xs font-bold">{discountPercentage}% OFF</span>
            </div>
            
            <Link to={`/coursepage/${course.id}`} 
              className={`px-3 py-2 rounded-lg font-medium text-sm text-white bg-gradient-to-r ${gradient} transition-all hover:shadow-md`}
            >
              Enroll Now
            </Link>
          </div>
        </div>
        
        {/* Quick Preview Overlay (appears on hover) */}
        <div 
          className={`absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-5 transition-opacity duration-300 ${
            isHovered ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <h3 className="text-lg font-bold text-white">{course.title}</h3>
          <p className="text-white/80 text-sm my-2">
            Master problem-solving with {course.problems}+ carefully selected problems, video solutions, and practice tests.
          </p>
          
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="bg-white/20 rounded-lg p-2 text-center">
              <p className="text-white text-xs">Difficulty</p>
              <p className="text-white font-bold text-sm">{course.difficulty}</p>
            </div>
            <div className="bg-white/20 rounded-lg p-2 text-center">
              <p className="text-white text-xs">Success Rate</p>
              <p className="text-white font-bold text-sm">92%</p>
            </div>
          </div>
          
          <div className="flex gap-2 mt-3">
            <Link to={`/coursepage/${course.id}`} className="flex-1 bg-white text-purple-800 py-2 rounded-lg font-medium text-sm hover:bg-gray-100 transition-colors">
              Sample Problems
            </Link>
            <Link to={`/coursepage/${course.id}`} className="flex-1 bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-2 rounded-lg font-medium text-sm hover:from-purple-700 hover:to-indigo-800 transition-colors">
              Enroll Now
            </Link>
          </div>
        </div>
      </div>
    );
  };

  // Get active courses
  const activeCourses = coursesByCategory[activeCategory] || [];
  // Add these state variables for scroll indicators
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    
    // Add this useEffect to handle scroll indicators
    useEffect(() => {
      const container = document.getElementById('courseScrollContainerArts');
      
      if (container) {
        const handleScroll = () => {
          const isNotAtStart = container.scrollLeft > 10;
          const isNotAtEnd = container.scrollLeft < (container.scrollWidth - container.clientWidth - 10);
          
          setShowLeftArrow(isNotAtStart);
          setShowRightArrow(isNotAtEnd);
        };
        
        // Initial check
        handleScroll();
        
        // Add scroll event listener
        container.addEventListener('scroll', handleScroll);
        
        // Cleanup
        return () => container.removeEventListener('scroll', handleScroll);
      }
    }, [activeCourses]); // Re-run when active class changes
    
    // Add these scroll handler functions
    const scrollLeft = () => {
      const container = document.getElementById('courseScrollContainer');
      if (container) {
        container.scrollBy({ left: -300, behavior: 'smooth' });
      }
    };
    
    const scrollRight = () => {
      const container = document.getElementById('courseScrollContainer');
      if (container) {
        container.scrollBy({ left: 300, behavior: 'smooth' });
      }
    };
  
  return (
    <div className="bg-gray-100 p-6">
      {/* Header and Category Filter Buttons */}
      <div className="max-w-6xl mx-auto mb-8">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Problem Solving Courses</h1>
        <p className="text-center text-gray-600 mb-6">Master JEE & NEET through intensive problem practice</p>
        
        <div className="flex flex-wrap justify-center gap-3 mb-6">
          {courseCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
                activeCategory === category.id
                  ? 'bg-gradient-to-r from-purple-600 to-indigo-700 text-white shadow-md'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>
      
      {/* Active Category Section */}
      <div className="max-w-6xl mx-auto mb-12">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800">
            {courseCategories.find(cat => cat.id === activeCategory)?.name}
          </h2>
          <div className="flex items-center gap-2">
            <span className="text-gray-500 text-sm">{activeCourses.length} courses</span>
            <span className="bg-purple-100 text-purple-800 text-xs font-medium px-2 py-1 rounded-full">Problem-Based</span>
          </div>
        </div>
        
        {activeCourses.length > 0 ? (
          // <div className="flex flex-wrap gap-6 justify-center">

          <div className="relative max-w-6xl mx-auto">
                  {/* Left scroll indicator */}
                  <div 
                    className={`absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 p-3 rounded-full shadow-lg cursor-pointer transition-all duration-300 hover:bg-purple-100 ${showLeftArrow ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                    onClick={scrollLeft}
                  >
                    <svg className="w-5 h-5 text-purple-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
                    </svg>
                  </div>

                  {/* Right scroll indicator */}
                  <div 
                    className={`absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 p-3 rounded-full shadow-lg cursor-pointer transition-all duration-300 hover:bg-purple-100 ${showRightArrow ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                    onClick={scrollRight}
                  >
                    <svg className="w-5 h-5 text-purple-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                  
                  {/* Scroll container */}
                  <div className="flex overflow-x-auto gap-6 pb-4 scroll-container hide-scrollbar" id="courseScrollContainerArts">
                    <div className="flex flex-nowrap gap-6">
                      {activeCourses.map((course, index) => (
                        <ProblemCourseCard key={`${activeCategory}-${index}`} course={course} />
                      ))}
                    </div>
                  </div>
                
          </div>
        ) : (
          <div className="text-center py-10 bg-white rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-700">No courses available yet</h3>
            <p className="text-gray-500 mt-2">We're working on adding new problem-solving courses in this category.</p>
          </div>
        )}
      </div>
      
      {/* Featured Instructors Section */}
      {/* <div className="max-w-6xl mx-auto mb-12 bg-white rounded-xl shadow-md overflow-hidden">
        <div className="p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Learn from Expert Instructors</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-center gap-4 p-4 rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50">
              <img 
                src="/api/placeholder/100/100" 
                alt="MG Hussain" 
                className="w-16 h-16 rounded-full object-cover"
              />
              <div>
                <h3 className="font-bold text-gray-900">MG Hussain</h3>
                <p className="text-sm text-gray-600">Physics, Chemistry & Maths Expert</p>
                <p className="text-xs text-gray-500 mt-1">Ex-IIT Faculty | 15+ years of teaching experience | Trained 10,000+ students</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4 p-4 rounded-lg bg-gradient-to-r from-teal-50 to-green-50">
              <img 
                src="/api/placeholder/100/100" 
                alt="Danish Sir" 
                className="w-16 h-16 rounded-full object-cover"
              />
              <div>
                <h3 className="font-bold text-gray-900">Danish Sir</h3>
                <p className="text-sm text-gray-600">Biology Specialist</p>
                <p className="text-xs text-gray-500 mt-1">AIIMS Gold Medalist | Author of 5+ books | 12+ years of teaching experience</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      
      {/* Course Features Section */}
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Why Choose Our Problem-Based Courses?</h2>
        
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Curated Problem Sets</h3>
            <p className="text-gray-600 text-sm">Carefully selected problems covering all exam patterns and difficulty levels.</p>
          </div>
          
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Video Solutions</h3>
            <p className="text-gray-600 text-sm">Detailed step-by-step video solutions for every problem by expert instructors.</p>
          </div>
          
          <div className="bg-white p-6 rounded-xl shadow-md">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">Performance Analytics</h3>
            <p className="text-gray-600 text-sm">Track your progress with detailed analytics and personalized recommendations.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemBasedCoursesApp;